import { ModeValue, DTSEARCH_MENU_ITEMS } from '@shared/types/frontend/searchHome';
import { useRouter } from 'next/router';
import { useSession } from '@/contexts/LitSessionProvider';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
interface FilterByTokenTypeProps {
  mode: ModeValue;
  setMode: React.Dispatch<React.SetStateAction<ModeValue>>;
  setKeyword: React.Dispatch<React.SetStateAction<string>>;
  customHandler?: boolean;
}
const FilterByTokenType = ({
  setMode,
  mode,
  setKeyword,
  customHandler = false
}: FilterByTokenTypeProps) => {
  const router = useRouter();
  const _filtersType = DTSEARCH_MENU_ITEMS.filter(item => {
    if (item.modeValue !== '' && item.modeValue !== 'Wild West') {
      const _normeiTypes = ['memes', 'hot', 'trending', 'gainers', 'new', 'native', 'cash', 'saved', 'top'];
      if (_normeiTypes.some(type => type === item.modeValue)) {
        return item;
      }
    }
  });
  const {
    PKP
  } = useSession();
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const handleToggle = (value: ModeValue) => {
    console.log('resetting keyword 1');
    setKeyword('');
    setMode(value);
    if (!customHandler) {
      const eventNameMap = {
        trending: EVENTS.search.viewHotTokens,
        top: EVENTS.search.viewTopTokens,
        memes: EVENTS.search.viewMemeTokens,
        native: EVENTS.search.viewNativeTokens,
        cash: EVENTS.search.viewCashTokens
      };
      const categoryMap = {
        trending: CATEGORIES.search,
        top: CATEGORIES.search,
        memes: CATEGORIES.search,
        native: CATEGORIES.search,
        cash: CATEGORIES.search
      };
      switch (value) {
        case 'trending':
          LogToMixpanel({
            pkp: PKP,
            eventName: eventNameMap[value],
            category: categoryMap[value]
          });
          break;
        case 'top':
          LogToMixpanel({
            pkp: PKP,
            eventName: eventNameMap[value],
            category: categoryMap[value]
          });
          break;
        case 'memes':
          LogToMixpanel({
            pkp: PKP,
            eventName: eventNameMap[value],
            category: categoryMap[value]
          });
          break;
        case 'native':
          LogToMixpanel({
            pkp: PKP,
            eventName: eventNameMap[value],
            category: categoryMap[value]
          });
          break;
        case 'cash':
          LogToMixpanel({
            pkp: PKP,
            eventName: eventNameMap[value],
            category: categoryMap[value]
          });
          break;
      }
      router.push({
        pathname: '/home',
        query: {
          ...router.query,
          mode: value
        }
      }, undefined, {
        shallow: true
      });
    }
  };
  return <div className={'flex items-center justify-between'} data-sentry-component="FilterByTokenType" data-sentry-source-file="FilterByTokenType.tsx">
      <ToggleGroup type='single' value={mode} onValueChange={handleToggle} className='justify-start pl-2 gap-4' data-sentry-element="ToggleGroup" data-sentry-source-file="FilterByTokenType.tsx">
        {_filtersType.map(item => <ToggleGroupItem key={item.label} value={item.modeValue} className={`
              data-[state=on]:bg-transparent
              data-[state=on]:text-white
              font-normal
              p-[0px]
              disabled:opacity-100 text-[20px] flex items-center 
              rounded-full text-genius-cream/50 h-[32px] py-[3px] 
              data-[state=off]:hover:bg-transparent`} disabled={item.modeValue === mode}>
            <p>
              {item.label === 'Natives' ? 'Core' : item.displayName ? item.displayName : item.label}
            </p>
          </ToggleGroupItem>)}
      </ToggleGroup>
    </div>;
};
export default FilterByTokenType;